// src/components/ErrorCodeChecker/ErrorCodeSelector.js

import React, { useState } from "react";
import { errorCodes } from "../../data/errorCodes";
import ErrorCodeDisplay from "./ErrorCodeDisplay";
import "../../styles/ErrorCodeChecker.css";

export default function ErrorCodeSelector() {
  const [deviceType, setDeviceType] = useState("");
  const [brand, setBrand] = useState("");

  const deviceTypes = Object.keys(errorCodes);
  const brands = deviceType ? Object.keys(errorCodes[deviceType]) : [];

  return (
    <div className="error-checker-container">
      <div className="error-code-header"> 
      <h2>🔍 Check Error Codes by Device</h2>
      </div>

      <div className="selectors">
        <label>
          Device Type:
          <select value={deviceType} onChange={(e) => {
            setDeviceType(e.target.value);
            setBrand(""); // reset brand when device changes
          }}>
            <option value="">Select Device</option>
            {deviceTypes.map((type) => (
              <option key={type} value={type}>{type}</option>
            ))}
          </select>
        </label>

        {deviceType && (
          <label>
            Brand:
            <select value={brand} onChange={(e) => setBrand(e.target.value)}>
              <option value="">Select Brand</option>
              {brands.map((b) => (
                <option key={b} value={b}>{b}</option>
              ))}
            </select>
          </label>
        )}
      </div>

      {deviceType && brand && (
        <ErrorCodeDisplay
          codes={errorCodes[deviceType][brand]}
          brand={brand}
          deviceType={deviceType}
        />
      )}
    </div>
  );
}
